// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","logo":"SectionHero_logo__xtf7g","headerWithLogo":"SectionHero_headerWithLogo__KiRBZ"};